import GameObject from '../../../GameObject/GameObject';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import GoldCard from '../../../Prototype/Level/Card/GoldCard';
import CardStateHelper from '../../../State/Card/CardStateHelper';
import { IGameState } from '../../../State/Game/IGameState';
import { AnimationClipEvent } from '../../Animation/AnimationClip';
import { StartAnimation, StopAnimation } from '../../Animation/AnimationHelper';
import { AUDIO_GOLD_CARD_REVEAL } from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';
import { StartAudio } from '../../Audio/AudioHelper';
import CardSystem from '../CardSystem';
import ValueCardHandler from './ValueCardHandler';

export default class GoldCardHandler extends ValueCardHandler {
    private goldCard: GoldCard;
    private goldContainer: GameObject;

    constructor(card: BaseCard) {
        super(card);

        this.goldCard = <GoldCard>card;

        const animationContainer = this.card.getChildByName(
            'animationContainer'
        );
        this.goldContainer = animationContainer.getChildByName('goldContainer');
    }

    public handleCardInPlay(state: IGameState, cardSystem: CardSystem) {
        super.handleCardInPlay(state, cardSystem);

        const cardBehavior = CardStateHelper.getCardBehavior(
            state,
            this.card.id
        );
        const isBlocked = cardBehavior.isBlocked(state);

        if (isBlocked !== this.goldCard.isBlocked) {
            StopAnimation(this.goldContainer);

            StartAnimation(this.goldContainer, 'DragonbonesDefault', {
                animationName: 'GoldCard_Collect',
                playTimes: 3,
            }).on(AnimationClipEvent.COMPLETE, () => {
                StartAnimation(this.goldContainer, 'DragonbonesDefault', {
                    animationName: 'GoldCard_Idle',
                });
            });

            StartAudio(
                this.card.scene,
                AUDIO_GOLD_CARD_REVEAL,
                AudioTrackType.SFX
            );
        }

        this.goldCard.isBlocked = isBlocked;
    }
}
